import { Observable } from 'rxjs';
import { useObservable as originalUseObservable } from 'rxjs-hooks';

export const useObservable = <T>(
  observableFactory: () => Observable<T>,
  initialValue?: T
): T => {
  return originalUseObservable(observableFactory, initialValue as T);
};
